var _rect, _rect2, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBgMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 422,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.262,
    y: -17.739,
    width: 429.739,
    height: 308.696,
    rx: 18.758,
    transform: "rotate(90 171.262 -17.739)",
    fill: "url(#text-bg-mob_svg__paint0_linear_4360_13011)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: -129,
    width: 161,
    height: 250,
    rx: 26.19,
    fill: "url(#text-bg-mob_svg__paint1_linear_4360_13011)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 381.5,
    r: 15.909,
    stroke: "#9948FF",
    strokeWidth: 3.182
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 411.5,
    r: 9.333,
    stroke: "#fff",
    strokeWidth: 2.333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-mob_svg__paint0_linear_4360_13011",
    x1: 386.131,
    y1: -17.739,
    x2: 386.131,
    y2: 290.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#1600E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#5C11C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "text-bg-mob_svg__paint1_linear_4360_13011",
    x1: 369.5,
    y1: -129,
    x2: 369.5,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#A900E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#481EE6"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEyIiBoZWlnaHQ9IjQyMiIgdmlld0JveD0iMCAwIDMxMiA0MjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjE3MS4yNjIiIHk9Ii0xNy43MzkiIHdpZHRoPSI0MjkuNzM5IiBoZWlnaHQ9IjMwOC42OTYiIHJ4PSIxOC43NTgxIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxNzEuMjYyIC0xNy43MzkpIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNDM2MF8xMzAxMSkiLz4KPHJlY3QgeD0iMjg5IiB5PSItMTI5IiB3aWR0aD0iMTYxIiBoZWlnaHQ9IjI1MCIgcng9IjI2LjE5IiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfNDM2MF8xMzAxMSkiLz4KPGNpcmNsZSBjeD0iMzE3LjUiIGN5PSIzODEuNSIgcj0iMTUuOTA5MSIgc3Ryb2tlPSIjOTk0OEZGIiBzdHJva2Utd2lkdGg9IjMuMTgxODIiLz4KPGNpcmNsZSBjeD0iMjQuNSIgY3k9IjQxMS41IiByPSI5LjMzMzMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuMzMzMzMiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl80MzYwXzEzMDExIiB4MT0iMzg2LjEzMSIgeTE9Ii0xNy43MzkiIHgyPSIzODYuMTMxIiB5Mj0iMjkwLjk1NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMDA3NjA1MTciIHN0b3AtY29sb3I9IiMxNjAwRTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjg2NTg5NiIgc3RvcC1jb2xvcj0iIzVDMTFDNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfNDM2MF8xMzAxMSIgeDE9IjM2OS41IiB5MT0iLTEyOSIgeDI9IjM2OS41IiB5Mj0iMTIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4wMDc2MDUxNyIgc3RvcC1jb2xvcj0iI0E5MDBFNSIvPgo8c3RvcCBvZmZzZXQ9IjAuODY1ODk2IiBzdG9wLWNvbG9yPSIjNDgxRUU2Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgTextBgMob as ReactComponent };